import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { MyIcon } from '../../common/baseConfig';
import { withRouter } from 'react-router-dom';
import { Button, Modal } from 'antd';
import * as actions from './redux/actions';

export class Sheet extends Component {
  static propTypes = {
    quesStore: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  getQuestionName(ID) {
    switch (ID) {
      case 1:
        return '单选题';
      case 2:
        return '多选题';
      case 3:
        return '填空题';
      case 4:
        return '判断题';
      case 5:
        return '问答题';
      case 6:
        return '计算题';
      case 7:
        return '组合题';
      case 8:
        return '多材料组合题';
      case 9:
        return '不定项';
      default:
        break;
    }
  }
  getClsName(data) {
    const { checkParsIndex, checkAllPars } = this.props.quesStore;
    const { QuestionType_ID } = data;

    if ((checkParsIndex.has(data.ID) || checkAllPars) && data.MyAnswer) {
      if (QuestionType_ID !== 1 && QuestionType_ID !== 2 && QuestionType_ID !== 4) {
        return 'active-item';
      }
      if (data.MyAnswer === data.Answer) {
        return 'correct-item';
      } else {
        return 'wrong-item';
      }
    }
    if (data.MyAnswer) {
      return 'active-item';
    }
    return '';
  }
  render() {
    const { ExamModel } = this.props;
    const {
      fetchQuesCreateChapterSuccess,
      checkAllPars,
      baseIndexArr,
      fetchGetExamDetailSuccess,
    } = this.props.quesStore;
    if (!fetchQuesCreateChapterSuccess && !fetchGetExamDetailSuccess) return null;

    let list = [],
      resultId = 0,
      PaperInfo = null;
    if (fetchQuesCreateChapterSuccess) {
      list = fetchQuesCreateChapterSuccess.list;
      resultId = fetchQuesCreateChapterSuccess.resultId;
    }
    if (fetchGetExamDetailSuccess) {
      list = fetchGetExamDetailSuccess.QuestionType;
      resultId = fetchGetExamDetailSuccess.ResultId;
      PaperInfo = fetchGetExamDetailSuccess.PaperInfo;
    }
    let listGroup = [];
    let wrongArr = [],
      correctArr = [],
      subArr = [],
      nullArr = [],
      total = 0;
    if (ExamModel === 0 || ExamModel === 1) {
      for (let i = 0; i < list.length; i++) {
        const item1 = list[i];
        total++;
        if (item1.MyAnswer) {
          if ([1, 2, 4].indexOf(item1.QuestionType_ID) !== -1) {
            //客观题
            if (item1.Answer !== item1.MyAnswer) {
              //错题集
              wrongArr.push(item1);
            } else {
              //对题集
              correctArr.push(item1);
            }
          } else {
            //主观题
            subArr.push(item1);
          }
        } else {
          nullArr.push(item1);
        }
        if (listGroup.length > 0) {
          const item2 = listGroup[listGroup.length - 1];
          if (this.getQuestionName(item1.QuestionType_ID) === item2.Name) {
            item1.Index = i;
            item2.data.push(item1);
          } else {
            item1.Index = i;
            listGroup.push({
              Name: this.getQuestionName(item1.QuestionType_ID),
              data: [].concat(item1),
            });
          }
        } else {
          item1.Index = i;
          listGroup.push({
            Name: this.getQuestionName(item1.QuestionType_ID),
            data: [].concat(item1),
          });
        }
      }
    } else {
      if (baseIndexArr.length > 0) {
        for (let i = 0; i < list.length; i++) {
          const ele = list[i];
          for (let j = 0; j < ele.Question.length; j++) {
            const element = ele.Question[j];
            total++;
            element.Index = baseIndexArr[i] + j;
            if (element.MyAnswer) {
              if ([1, 2, 4].indexOf(element.QuestionType_ID) !== -1) {
                //客观题
                if (element.Answer === element.MyAnswer) {
                  correctArr.push(element);
                } else {
                  wrongArr.push(element);
                }
              } else {
                //主观题
                subArr.push(element);
              }
            } else {
              nullArr.push(element);
            }
          }
          listGroup.push({ Name: ele.TypeInfo.QuestionType_Name, data: ele.Question });
        }
      }
    }

    return (
      <div
        className="ques-store-sheet"
        style={ExamModel === 0 ? { minHeight: 725 } : { height: 526 }}
      >
        <h2>
          <MyIcon type="icondatiqia" className="icon" />
          <span>答题卡</span>
          {(ExamModel === 1 || ExamModel === 2) && (
            <span className="counts">
              {wrongArr.length + subArr.length + correctArr.length}/{total}
            </span>
          )}
        </h2>
        <div
          className="answer-sheet-list"
          style={
            ExamModel === 1 || ExamModel === 2
              ? { height: 358, overflowY: 'auto' }
              : { height: 535, overflowY: 'auto' }
          }
        >
          {listGroup.length > 0 &&
            listGroup.map(item => (
              <div className="group" key={item.Name}>
                <h3>{item.Name}</h3>
                <ul>
                  {item.data.map(it => (
                    <li
                      className={this.getClsName(it)}
                      key={it.Index}
                      onClick={() => {
                        this.props.actions.updateCurQuesIndex({ payload: it.Index });
                      }}
                    >
                      {it.Index + 1}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
        </div>
        {ExamModel === 0 && (
          <div className="answer-sheet-prac-tip">
            <div className="tip">
              <p>
                <span className="wrong"></span>
                <span>错误</span>
                <span>{wrongArr.length}</span>
              </p>
              <p>
                <span className="correct"></span>
                <span>正确</span>
                <span>{correctArr.length}</span>
              </p>
              <p>
                <span className="noDone"></span>
                <span>未做</span>
                <span>{nullArr.length}</span>
              </p>
            </div>
            <Button
              type="theme"
              onClick={() => {
                let noDoneCounts = nullArr.length;

                Modal.confirm({
                  title: noDoneCounts === 0 ? '已完成所有练习题' : `还有${noDoneCounts}题未做`,
                  content: '是否退出章节练习并提交？',
                  okText: '确认',
                  cancelText: '取消',
                  onOk: () => {
                    let params = {};
                    let arr = [];
                    correctArr.forEach(item => {
                      arr.push({
                        ID: item.ID,
                        MyAnswer: item.MyAnswer,
                        Judge: 1,
                        QuestionType_ID: item.QuestionType_ID,
                      });
                    });
                    wrongArr.forEach(item => {
                      arr.push({
                        ID: item.ID,
                        MyAnswer: item.MyAnswer,
                        Judge: 0,
                        QuestionType_ID: item.QuestionType_ID,
                      });
                    });
                    nullArr.forEach(item => {
                      arr.push({
                        ID: item.ID,
                        MyAnswer: '',
                        Judge: 0,
                        QuestionType_ID: item.QuestionType_ID,
                      });
                    });
                    params = {
                      resultId,
                      list: arr,
                    };
                    this.props.actions.fetchSubmitPra(params).then(res => {
                      if (res.SuccessResponse) {
                        this.props.history.goBack();
                      }
                    });
                  },
                });
              }}
            >
              结束练习
            </Button>
          </div>
        )}
        {ExamModel === 1 && (
          <div className="answer-sheet-exam-tip">
            {checkAllPars && (
              <div className="tip">
                <p>
                  <span className="wrong"></span>
                  <span>错误</span>
                  <span>{wrongArr.length}</span>
                </p>
                <p>
                  <span className="correct"></span>
                  <span>正确</span>
                  <span>{correctArr.length}</span>
                </p>
                <p>
                  <span className="noDone"></span>
                  <span>未做</span>
                  <span>{nullArr.length}</span>
                </p>
              </div>
            )}
            {!checkAllPars && (
              <div className="tip">
                <p>
                  <span className="done"></span>
                  <span>已做</span>
                  <span>{correctArr.length + wrongArr.length}</span>
                </p>
                <p>
                  <span className="noDone"></span>
                  <span>未做</span>
                  <span>{nullArr.length}</span>
                </p>
              </div>
            )}
            <Button
              type="theme"
              onClick={() => {
                if (checkAllPars) {
                  //退出判断
                  this.props.history.goBack();
                  return;
                }
                let noDoneCounts = nullArr.length;
                Modal.confirm({
                  title:
                    noDoneCounts === 0 ? (
                      <p>已完成所有练习题，是否确定交卷？</p>
                    ) : (
                      <p>
                        您还有<span style={{ color: '#f01414' }}>{noDoneCounts}</span>
                        题未作答，是否确定交卷？
                      </p>
                    ),
                  okText: '确认交卷',
                  cancelText: noDoneCounts === 0 ? '取消' : '继续做题',
                  onOk: () => {
                    let params = {};
                    let arr = [];
                    correctArr.forEach(item => {
                      arr.push({
                        ID: item.ID,
                        MyAnswer: item.MyAnswer,
                        Judge: 1,
                        QuestionType_ID: item.QuestionType_ID,
                      });
                    });
                    wrongArr.forEach(item => {
                      arr.push({
                        ID: item.ID,
                        MyAnswer: item.MyAnswer,
                        Judge: 0,
                        QuestionType_ID: item.QuestionType_ID,
                      });
                    });
                    nullArr.forEach(item => {
                      arr.push({
                        ID: item.ID,
                        MyAnswer: '',
                        Judge: 0,
                        QuestionType_ID: item.QuestionType_ID,
                      });
                    });
                    params = {
                      resultId,
                      list: arr,
                    };
                    this.props.actions.fetchSubmitPra(params).then(res => {
                      if (res.SuccessResponse) {
                        Modal.confirm({
                          title: '交卷成功，是否查看解析？',
                          okText: '查看解析',
                          cancelText: '再来一批',
                          onOk: () => {
                            //查看所有解析
                            this.props.actions.updateCheckAllPars({ payload: true });
                          },
                          onCancel: () => {
                            window.location.reload();
                          },
                        });
                      }
                    });
                  },
                });
              }}
            >
              {checkAllPars ? '退出' : '交卷'}
            </Button>
          </div>
        )}
        {ExamModel === 2 && (
          <div className="answer-sheet-exam-tip">
            {checkAllPars && (
              <div className="tip">
                <p>
                  <span className="wrong"></span>
                  <span>错误</span>
                  <span>{wrongArr.length}</span>
                </p>
                <p>
                  <span className="correct"></span>
                  <span>正确</span>
                  <span>{correctArr.length}</span>
                </p>
                <p>
                  <span className="noDone"></span>
                  <span>未做</span>
                  <span>{nullArr.length}</span>
                </p>
              </div>
            )}
            {!checkAllPars && (
              <div className="tip">
                <p>
                  <span className="done"></span>
                  <span>已做</span>
                  <span>{wrongArr.length + subArr.length + correctArr.length}</span>
                </p>
                <p>
                  <span className="noDone"></span>
                  <span>未做</span>
                  <span>{nullArr.length}</span>
                </p>
              </div>
            )}
            <Button
              type="theme"
              onClick={() => {
                if (checkAllPars) {
                  //退出判断
                  if (PaperInfo.ExamPaperType === 0) {
                    this.props.history.push('/center/startExer/2');
                  } else {
                    this.props.history.push('/center/startExer/1');
                  }
                  return;
                }
                let noDoneCounts = nullArr.length;
                Modal.confirm({
                  title:
                    noDoneCounts === 0 ? (
                      <p>已完成所有练习题，是否确定交卷？</p>
                    ) : (
                      <p>
                        您还有<span style={{ color: '#f01414' }}>{noDoneCounts}</span>
                        题未作答，是否确定交卷？
                      </p>
                    ),
                  okText: '确认交卷',
                  cancelText: noDoneCounts === 0 ? '取消' : '继续做题',
                  onOk: () => {
                    let params = {};
                    let arr = [];
                    correctArr.forEach(item => {
                      arr.push({
                        ID: item.ID,
                        MyAnswer: item.MyAnswer,
                        Judge: 1,
                        QuestionType_ID: item.QuestionType_ID,
                      });
                    });
                    wrongArr.forEach(item => {
                      arr.push({
                        ID: item.ID,
                        MyAnswer: item.MyAnswer,
                        Judge: 0,
                        QuestionType_ID: item.QuestionType_ID,
                      });
                    });
                    subArr.forEach(item => {
                      arr.push({
                        ID: item.ID,
                        MyAnswer: item.MyAnswer,
                        Judge: 0,
                        QuestionType_ID: item.QuestionType_ID,
                      });
                    });
                    nullArr.forEach(item => {
                      arr.push({
                        ID: item.ID,
                        MyAnswer: '',
                        Judge: 0,
                        QuestionType_ID: item.QuestionType_ID,
                      });
                    });
                    params = {
                      resultId,
                      list: arr,
                    };
                    this.props.actions.fetchSubmitPra(params).then(res => {
                      if (res.SuccessResponse) {
                        Modal.confirm({
                          title: '交卷成功，是否查看解析？',
                          okText: '查看解析',
                          cancelText: '返回列表',
                          onOk: () => {
                            //查看所有解析
                            this.props.actions.updateCheckAllPars({ payload: true });
                          },
                          onCancel: () => {
                            if (PaperInfo.ExamPaperType === 0) {
                              this.props.history.push('/center/startExer/2');
                            } else {
                              this.props.history.push('/center/startExer/1');
                            }
                          },
                        });
                      }
                    });
                  },
                });
              }}
            >
              {checkAllPars ? '退出' : '交卷'}
            </Button>
          </div>
        )}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    quesStore: state.quesStore,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Sheet));



// WEBPACK FOOTER //
// ./src/features/ques-store/Sheet.js